import {
    useAssignSetting,
    useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_CONSUMER_REDIRECTS_250825 } from "@faire/retailer-settings/FE_CONSUMER_REDIRECTS_250825";

export const useSettingConsumerRedirects = (): boolean =>
  useSetting(FE_CONSUMER_REDIRECTS_250825);

export const useAssignSettingConsumerRedirects = () =>
  useAssignSetting(FE_CONSUMER_REDIRECTS_250825);